module.exports = __webpack_public_path__ + "img/HUAWEI.b7a8fcf3.png";